import { StoreBaseHandler } from "../../infrastructure/base-handlers";
import { removeActivityHistoryItem } from "./action";
import { RemoveHistoryItemPayload } from "./request";

export class RemoveHistoryItemHandler extends StoreBaseHandler {
  async handle(payload: RemoveHistoryItemPayload) {
    try {
      this.store.dispatch(
        removeActivityHistoryItem({
          id: payload.entityId,
          itemId: payload.itemId,
        }),
      );
    } catch (e) {
      console.error(e.message);
    }
  }
}
